import React, { useContext } from "react";
import "./common.css";
import "aos/dist/aos.css";
import Type from "./Type";
import { ThemeContext } from "../context/ThemeContext";

const Hero = () => {
  const { Theme } = useContext(ThemeContext)
  return (
    <section
      id="home"
      className={`lg:h-[110vh] flex items-center ${Theme === "dark" ? "darkBackground" : "lightBackgound"} lg:bg-cover lg:bg-center lg:bg-no-repeat py-32 lg:py-0 overflow-hidden`}
    >
      <div className="container mx-auto h-full">
        <div className="flex items-center h-full pt-20">
          <div className="flex-1 flex flex-col items-center lg:items-start scale-up-center ">
            <p className={`pt-4  md:pt-6 md:pb-12 max-w-[580px] text-4xl md:text-5xl lg:text-7xl text-center text-${Theme === "dark" ? "[#F2AA4CFF]" : "black-400/50"} lg:text-left`}>
              Monu Yadav
            </p >
            <Type />
            <a href="https://drive.google.com/uc?export=download&id=19uosWZY4Z7TO0kD4c0Ia9kSKqPQUewRA" target={"blank"} className={`relative inline-flex bg-white items-center px-12 py-3 overflow-hidden text-lg font-medium ${Theme === "dark" ? "text-[#F2AA4CFF]" : "text-red-400"} border-2 ${Theme === "dark" ? "border-[#F2AA4CFF]" : "border-red-400"} rounded-full  hover:text-white  group hover:bg-gray-50`}>
              <span className={`absolute left-0 block w-full h-0 transition-all bg-${Theme === "dark" ? "[#F2AA4CFF]" : "red-400"} ${Theme === "dark" ? "text-black-400" : "text-white"} opacity-100 group-hover:h-full top-1/2 group-hover:top-0 duration-400 ease`}></span>
              <span className={`absolute right-0 flex items-center  justify-start w-10 h-10  duration-300 transform translate-x-full group-hover:translate-x-0 ease`}>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
              </span>
              <span className="relative">Download Resume</span>
            </a>
          </div>
          <div className={`hidden sm:flex flex-1 justify-end mb-10 rounded-full items-end max-w-lg border-4  ${Theme === "dark" ? "border-[#F2AA4CFF]" : ' border-red-400'} `}>
            <img className={`slide-up-center imageMonu rounded-full  bg-white`} src={"https://i.ibb.co/CvgCGgC/Picsart-23-01-06-19-52-24-727.png"} alt="Monu" />
            {/* <MyProfile /> */}

          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
